import { useEffect, useState } from "react";
import { IAboutusContainerProps } from "./Aboutus.interfaces";
import AboutusView from "./Aboutus.view";
import BroswerService from "../../Services/Browser.service";
export default function AboutusContainer(props: IAboutusContainerProps) {
    useEffect(() => {
        BroswerService.setCustomTitle("AboutusContainer");
    }, []);

    const [showlogin, setShowlogin] = useState(false);
    const loginController = () => setShowlogin(!showlogin);
    const [showDemo, setShowDemo] = useState(false);
    const demoController = () => setShowDemo(!showDemo);
    return (
        <>
            <AboutusView
                // loginController={loginController}
                showlogin={showlogin}
                demoController={demoController}
                showDemo={showDemo}
            />
        </>
    );
}
